import { Carousel } from "react-responsive-carousel";
import { Link } from "react-router-dom";
import { Card, Col, Row } from "reactstrap";
import { H6, Image, P } from "../../../../AbstractElements";
import { topDealerCarouselData } from "../../../../Data/Dashboard/EcommerceDashboard/EcommerceDashboard";
import { dynamicImage } from "../../../../Service";
import { Href, ViewMore } from "../../../../utils/Constant";

const TopDealerCarousel = () => {
  return (
    <Carousel autoPlay showIndicators={false} swipeable={true} infiniteLoop showStatus={false} emulateTouch className="top-dealer-carousel">
      {topDealerCarouselData.map((data, index) => (
        <div className='item' key={index}>
          <Row>
            {data.user.slice(0, 4).map((user, userIndex) => (
              <Col key={userIndex} md='6' lg='3' className='carousel-col'>
                <Card>
                  <div className='top-dealerbox text-center'>
                    <Image className='card-img-top' src={dynamicImage(`dashboard-2/user/${user.src}`)} alt='users' />
                    <H6>{user.name}</H6>
                    <P>{user.place}</P>
                    <Link className='btn btn-rounded' to={Href}>
                      {ViewMore}
                    </Link>
                  </div>
                </Card>
              </Col>
            ))}
          </Row>
          <Row className="dashboard-slider">
            {data.user.slice(4, 8).map((user, userIndex) => (
              <Col key={userIndex} md='6' lg='3' className='carousel-col'>
                <Card>
                  <div className='top-dealerbox text-center'>
                    <Image className='card-img-top' src={dynamicImage(`dashboard-2/user/${user.src}`)} alt='users' />
                    <H6>{user.name}</H6>
                    <P>{user.place}</P>
                    <Link className='btn btn-rounded' to={Href}>
                      {ViewMore}
                    </Link>
                  </div>
                </Card>
              </Col>
            ))}
          </Row>
        </div>
      ))}
    </Carousel>
  );
};

export default TopDealerCarousel;


 

